export default {
  lang: {
    CustomerUser: 'Customer User',
    switchTo: 'Switch to',
    internetOffline: 'Internet connection failed, please try again later.',
    systemAdmin: 'Системный администратор',
    /* ---- title ---- */
    titlePre: 'TVU Командный Центр3.0',
    TMySource: 'Мои источники',
    TAdvanceControl: 'Расширенный контроль',
    TMultiControl: 'Multi Control',
    TMyReceivers: 'Мои приемники',
    TSetting: 'Настройка',
    TMultiView: 'Полиэкран',
    TShare: 'Публикация',
    TToken: 'Токен',
    TAlert: 'Оповещение',
    GridViaToken: 'TVU Grid Via Token',
    GlobalGrid: 'Global Grid',

    title: 'Командный Центр',
    title1: 'Переключение',
    deviceSource: 'Источник',
    source: 'Источник',
    i18n_source: 'Источник',
    destination: 'Адресат',
    i18n_destination: 'Адресат',
    grid: 'TVU Грид',
    all: 'Все',
    i18n_all: 'Все',
    live: 'Жить',
    home_Live: 'Жить',
    live_OnHold: 'Live on hold',
    online: 'Онлайн',
    home_EnterReceiverNamePeerID: 'Введите имя получателя/PeerID',
    home_Online: 'Онлайн',
    offline: 'Оффлайн',
    sort: 'Сортировать по статусу',
    favorite: 'Избранное',
    status: 'Статус',
    total: 'Всего',
    stop: 'Стоп',
    Stop: 'Стоп',
    end: 'Стоп',
    Switch: 'Переключить',
    Take: 'Переключить',
    of: 'Of',
    notSource: 'Пожалуйста выберите источник',
    ParamError: 'Ошибка сервера, пожалуйста свяжитесь с поддержкой TVU',
    SendToRFail: 'Ошибка сервера, пожалуйста свяжитесь с поддержкой TVU',
    ReceiverNotFound: 'Приёмник не найден, пожалуйста уточните и попробуйте ещё раз',
    ReceiverOffLine: 'Приемник выключен',
    DeviceOffLine: 'Источник выключен',
    RnotfoundthisSource: 'Источник не найден, пожалуйста уточните и попробуйте снова',
    ReceiverNotLive: 'Трансляция на приëмнике остановлена',
    ReceiverNotLiveWithSource: 'Прямая трансляция между приёмником и источником не установлена',
    selectWebrtcSource: 'Извините ... Предпросмотр видео сейчас недоступен. Пожалуйста проверьте настройки WebRTC на устройстве',
    timeOut: 'Время запроса истекло, пожалуйста попробуйте позже',
    // WR-346: 初始化接口超时后守卫兜底放行，页面无用户信息时的提示；本仓 ru 缺 retry，一并补齐 [Claude Code]
    initUserInfoFailedTips: 'Не удалось загрузить информацию об аккаунте. Некоторые функции могут быть недоступны.',
    retry: 'Повторить',
    // WR-346 F: 重定向循环断路后的提示（账号没有任何可访问页面）[Claude Code]
    pagePermissionInvalidTips: 'Для вашей учётной записи нет доступных страниц. Обратитесь к администратору.',
    // WR-346 B: initConfig（全局配置）加载失败时的提示 [Claude Code]
    initConfigFailedTips: 'Не удалось загрузить конфигурацию. Некоторые функции могут работать некорректно.',
    pleaseWait: 'Запрос послан, пожалуйста ожидайте',
    modelTips: 'Полезная информация',
    rpsTakeAllOccupied: 'Следующие приёмники уже ведут трансляцию для другого источника. Заменить их?',
    rpsTakeAllOccupiedOne: 'Следующий приёмник уже ведёт трансляцию для другого источника. Заменить его?',
    rpsTakeAllSkip: 'Пропустить',
    rpsTakeAllError: 'Не удалось запустить все',
    startAll: 'Запустить все',
    error: 'Ошибка',
    close: 'Нет',
    i18n_no: 'Нет',
    updateBrowser: 'Для лучшего отображения используйте последнюю версию Chrome',
    guideSelT: 'Выберите источник для перехода',
    guideDesVideo: 'Опишите видео',
    guideFavorite: 'Отметьте, чтобы внести в избранное',
    next: 'Следующий',
    goIt: 'Иди',
    notSwitch: 'Невозможно переключиться на тот же источник',
    loading: 'Загружается',
    i18n_loading: 'Загружается~',
    stopping: 'Остановлен',
    receiverisnotexist: 'Указанный приёмник недоступен',
    receiverNotLiveWithCurrentSource: 'Источник не осуществляет трансляцию с данным приемником',
    rIsNotLiving: 'Данный приёмник не осуществляет трансляцию',
    localSourceCanNotStop: 'Приёмник транслирует сигнал с локального видео входа. Не может быть остановлен',
    sourceNotLiveWithCurrentReceiver: 'Истоник не осуществляет трансляцию с данным приемником',
    cameraOff: 'Камера не подключена!',
    ReceiverOnLive: 'Данный приёмник сейчас осуществляет трансляцию с другого передатчика. Вы желаете остановить ее и начать трансляцию с этого передатчика?',
    ReceiverOnLive1: 'Данный приёмник сейчас осуществляет трансляцию с другого передатчика',
    ReceiverOnLive2: 'Вы желаете остановить ее и начать трансляцию с этого передатчика?',
    ReceiverDeviceOnLine: 'Данный передатчик сейчас осуществляет трансляцию на другой приемник. Вы желаете остановить ее и начать трансляцию с этим приемником?',
    ReceiverDeviceOnLine1: 'Данный передатчик сейчас осуществляет трансляцию на другой приемник',
    ReceiverDeviceOnLine2: 'Вы желаете остановить ее и начать трансляцию с этим приемником?',
    i18n_transimitterLiveReceiver: 'Данный передатчик сейчас осуществляет трансляцию на другой приемник. Вы желаете остановить ее и начать трансляцию с этим приемником?',
    home_transimitterLiveReceiver: 'Данный передатчик сейчас осуществляет трансляцию на другой приемник. Вы желаете остановить ее и начать трансляцию с этим приемником?',
    i18n_stopLiveFailed: 'Не удалось остановить трансляцию',
    i18n_startLiveFailed: 'Не удалось запустить трансляцию',
    vaildVal: 'Допустимое значение {0}<->{1}',
    adminUser: 'Учетная запись  поддержки или главного администратора временно недоступна для данной системы',
    netStop: 'Прерывание соединения с сетью ...',
    i18n_yes: 'Да',
    confirm: 'Да',
    cancel: 'Отмена',
    PHSearch: 'Поиск видео или трансивера',
    NoResult: 'Ничего не найдено',
    DeviceNoSource: 'Источник некорректен, пожалуйста проверьте видео соединение',
    inputDescrible: 'Название сюжета',
    searchT: 'Название источника',
    versionLow61: 'Версия программного обеспечения источника устарела. Необходимо установить обновление',
    // Start && stop live code
    isBooking: 'Получатель выполняет событие резервирования',
    currentRLiveSourceNotBelongToUser: 'Текущий живой источник не принадлежит текущему пользователю.',
    receiverNotConnect: 'Приемник не подключен',
    notHaveStartauthor: 'Нет разрешения на запуск Live, обратитесь в службу технической поддержки',
    notHaveStoptauthor: 'Разрешение No Stop Live, пожалуйста, свяжитесь со службой технической поддержки',
    notHaveVoipauthor: 'Нет разрешения VoIP, пожалуйста, свяжитесь со службой технической поддержки',
    // Add ext
    success: 'успех',

    enditFailed: 'Редактировать не удалось',
    // My Receiver Page
    rinputDescrible: 'Введите памятку',
    sourceFrom: 'Источник от',
    newMyRecevierInputTitle: 'Видео или Направление',
    newMyRecevierSort: 'Сортировать по статусу',
    receiverDataIsEmpty: 'Receiver data empty',
    recevierMyFavorite: 'Мое любимое',
    addFavoriteSuccess: 'Добавьте к любимому успеху.',
    EnterSourceNamePeerID: 'Введите имя источника/PeerID',
    notSupportFunction: 'Not support this operation',

    // advance control
    moreThanLimitation: 'Max number of previews - {0} has been reached. Please turn off other preview windows first.',
    syncTitle: 'Time Lock is only availble when selected receivers are live with TVU Pack',
    syncCanUseTitle: '启动失败,请检查R和T的版本是否都大于6.1(包含6.1)，如果是的，请至少选择2个以上的R',

    notHaveSyncFeature: 'Device {0} not access tpc time lock feature',
    synchronizing: 'Device is synchronizing',
    deviceSynchronizing: 'Exist device synchronizing by other account',
    maxMultiControlNumber: 'You can only select six video to preview',
    notLastOne: 'You need to delete from last one',
    picturesFormat: 'The max picture size is 480*640',
    theSameDevice: 'The current device is already exists',

    /* ---- home ---- */
    // new home
    receiverControlTitle: 'Receiver Control',
    sourceControlTitle: 'Source Control',
    adjustCamera: 'Adjust Camera',
    dynamicsorting: 'Dynamic Sorting',
    serverFailed: 'Server exception',
    modeSwitching: 'Mode switching, please operate later',
    anywhereTimeout: 'Anywhere connection timed out, please check device settings or contact technical support.',

    // new multiview
    cannotSwitchSplitScreenMode: 'Your current video number is larger than you want to switch the split-screen mode, can not switch!',
    rVerionNeedV56Above: 'The receiver software requires to be v5.6 or above.',
    showInfo: 'Show Info',
    audioMeter: 'Audio meter',
    AddToCall: 'Add to call',
    startToCall: 'Start the call',
    selectMonitorSelectCall: 'Only TVUPack and TVU Anywhere support VoIP.',
    selectObjCall: 'Please select which you want to establish the voice call with.',
    setVideoFeedbackTrueViewVideo: 'Video preview is disabled. Please enable it or contact TVU support for assistance.',
    setVideoFeedbackTrueViewVideoMoreLive: 'Max number of previews - 5 has been reached. Please turn off other preview windows first.',
    continueCall: 'Continue call',
    interruptAllCall: 'Would you like to end the active calls?',
    interruptAll: 'Hang up',
    file: 'File',
    addfile: 'Add File',
    addFolder: 'Add Folder',
    addMedia: 'Add Media',
    Folder: 'Folder',
    selectAFolder: 'Select a folder',
    addvideo: 'Add Local Video',
    editfile: 'Edit File',
    fileName: 'File name',
    bookingImportFile: 'Import Excel or CSV files to add in batches.',
    bookingImportFileTemp: 'View file template.',
    search: 'Search',
    bookingChannel: 'Channel',
    bookingDeleteFail: 'Some file is being used by an event and cannot be deleted',
    bookingEditFail: 'Some events are using this file and cannot be modified',
    durationEmpty: 'Duration connot be empty.',
    durationType: 'Duration need enter a positive integer',
    durationUnit: '( s )',
    upload: 'Upload',
    proccessing: 'Proccessing...',
    uploadVideoLocal: 'Upload local video file',
    uploadHasSame: 'The file you selected has already been uploaded',
    selectAVideo: 'Please select a video to add.',
    videoExist: 'Video already exists',
    noConnection: 'Нет соединения',
    fileNeedType: 'Upload files can only be in xls, xlsx, csv format!',
    videoNeedType: 'Upload videos can only be in ts,rm,rmvb,wmv,wtv,avi,3gp,mkv,mpg,video/mpeg,video/mp4,mov format!',
    // playout
    fileNotformat: 'The file content format is incorrect',
    noAvailable: 'N / A',
    monitorUserTips: 'Are you sure you want to View this user?',
    gotoSupportTips: 'Are you sure you want to return to the support account?',
    deviceNameBytes: 'Device name can not exceed 15 bytes.',
    // CC-2288: RPS 子设备改名——该文件现有 deviceNameBytes 即英文，沿用英文保持一致 [Claude Code]
    rpsDeviceNameBytes: 'Device name (excluding the _NN channel suffix) can not exceed 12 bytes.',
    // WR-318 device rename error codes
    slaveRenameNotAllowed: 'This device is a slave device and cannot be renamed directly. Please edit its master device (PID: {pid}).',
    renameParamError: 'Request parameter error, please try again',
    renameNoRights: 'No permission or the device does not exist',
    deviceNameValidateFailed: 'Device name validation failed',
    renameRetryLater: 'Rename failed, please try again later',
    deviceOfflineRetry: 'Device is offline or not registered, please try again later',
    deviceTypeError: 'Device type error, please contact support',
    VirtualCloudR: 'Virtual Cloud Receiver',
    mediaFolder: 'Media',

    // setting
    instanceId: 'Instance id',
    rId: 'Receiver ID',
    Ip: 'IP',
    creater: 'Starter',
    startTime: 'Start Time',
    operation: 'Operation',
    stopR: 'Stop Receiver',
    stopTime: 'Shutdown time',
    shutdownP: 'Closer',
    Shutdown: 'Shut-down',
    ShutdownTime: 'Shut-down Time',
    startUpCloudR: 'Start-up Cloud Receiver',
    ending: 'Ending',
    ClosedBySupport: 'Closed By Support',
    ClosedBySystem: 'Closed By System',
    canUseArea: 'Available area',
    selectArea: 'Please select a region you want to start',
    connectTpcFail: 'Connect TPC failed',
    connectInstanceFail: 'Connect Instance-service failed',
    getRegionFail: 'Get active region failed',
    createInsFail: 'Create instance failed',
    shutdownInsFail: 'Shutdown instance failed',
    userInsnull: 'User instance is not exist',
    userInsreadyCLose: 'User instance already closed',
    confirmShutDown: 'Are you sure you want to shut it down?',
    virtualRDes: 'Virtual Cloud Receiver',

    // multiview plus

    workspace: 'Workspace',
    currentDevice: 'Current Device',
    workspaceList: 'Workspace List',
    newWorkspace: 'New Workspace',
    enternewWorkspace: 'Enter new workspace',
    plzSelectLayout: 'Please select layout.',
    plzEnterspaceName: 'Please enter workspace name.',
    duplicate: 'Duplicate',
    deleteSpace: 'Are you sure you want to delete this workspace?',
    BacktoView: 'Back to View',
    ManageWorkspace: 'Manage Workspace',
    addTo: 'Add to',
    moveTo: 'Move to',
    copyTo: 'Copy to',
    newWorkSpace: 'New Workspace',
    moveSuccess: 'Move Success',
    copySuccess: 'Copy Success',
    addSuccess: 'Add Success',
    deleteSuccess: 'Delete Success',
    deleteInfo: 'Are you sure you want to remove this device from current workspace?',
    ManageDevices: 'Manage Devices',
    showDesc: 'Show Description',
    mvpRecevierSort: 'Sort by name',
    tomultiview: 'Go Multi-view',
    tomultiviewplus: 'Go Multi-view-plus',
    Rename: 'Rename',
    Enter: 'Enter',
    Duplicate: 'Duplicate',
    Delete: 'Delete',
    dragAndDrop: 'Drag and drop to sort',

    menuNoPermission: 'Для авторизации, пожалуйста, свяжитесь с тезнической поддержкой.',
    mvNoPermission: 'В данный момент у вас нет лицензии для использования этой функции. Для дополнительной информации, пожалуйста свяжитесь с технической поддержкой.',
    tkNpPermission: 'В данный момент у вас нет лицензии для использования этой функции. Для дополнительной информации, пожалуйста свяжитесь с технической поддержкой.',
    // WR-278 Apple Watch device activation
    TActivateDevice: 'Активация устройства',
    AppleWatch: 'Apple Watch',
    activationTime: 'Время активации',
    operate: 'Действие',
    Confirm: 'Подтвердить',
    watchActivateTitle: 'Активация устройства',
    watchActivateTip: 'Введите код, показанный на экране ваших часов.',
    watchCode: 'Код',
    watchContinue: 'Продолжить',
    watchActivateSuccess: 'Ваши часы активированы. Вы можете вернуться к часам.',
    watchStatusActive: 'Активно',
    watchStatusPending: 'Ожидание',
    watchStatusInvalid: 'Недействительно',
    watchActivateDialogTitle: 'Активировать мои часы',
    watchActivateFailed: 'Не удалось выполнить активацию. Повторите попытку.',
    watchCodeInvalid: 'Неверный код. Проверьте и попробуйте снова.',
    watchCodeExpired: 'Срок действия кода истёк. Начните активацию на часах заново.',
    watchCodeUsed: 'Этот код уже был использован.',
    watchRemoveConfirmTitle: 'Вы уверены, что хотите удалить эти часы?',
    watchRemoveConfirmLose: '«{0}» немедленно потеряет доступ.',
    watchRemoveConfirmReactivate: 'Чтобы снова получить доступ, потребуется активировать их с новым кодом часов.',
    watchRemoveFailed: 'Не удалось удалить часы. Повторите попытку.',
    lowVersionRefreshTips: 'Обратите внимание: версии ниже 7.5 не поддерживают автоматическое обновление',
    // WR-323: 接收机实时预览禁用提示 [Claude Code]
    livePreviewDisabledHint: 'Предпросмотр видео на данном ресивере в данный момент отключён для экономии ресурсов. Пожалуйста, перейдите к ресиверу и включите его в настройках ресивера при необходимости.',
    // WR-323: 设置里禁用实时预览开关 label + 帮助 tooltip [Claude Code]
    disableLivePreviewLabel: 'Отключить предпросмотр видео в реальном времени для экономии аппаратных ресурсов',
    disableLivePreviewTip: 'Обратите внимание, что этот параметр отключит предпросмотр видео в реальном времени во всех сервисах, включая веб-управление ресивером и Command Center, для данного ресивера.',
    /* ---- RPS Encoder / HDR / Chroma (rpsv3-131-yuv422-hdr-chroma) ---- */
    HDRHLG: 'HDR/HLG',
    HDRHLGAutoFor10bit: 'Авто для 10-бит',
    HDRHLGHlgFor10bit: 'HLG для 10-бит',
    HDRHLGWithoutHDRHLG: '10-бит без HDR/HLG',
    HDRHLGForced8bit: 'Принудительный 8-бит',
    ChromaSubsampling: 'Цветовая субдискретизация',
    ChromaSourceNotSupport422: 'Источник не поддерживает 4:2:2',
    ChromaParamInvalid: 'Недопустимый параметр, ошибка настройки',
    // RPSV3-170: текст подсказки для отключённого 4:2:2, когда оборудование не поддерживает 422 10bit [Claude Code]
    ChromaHwNotSupport422: 'Это оборудование не поддерживает 4:2:2 (422 10-бит)',
    // RPSV3-170: причина отключения трёх 10-bit опций HDR/HLG при отсутствии поддержки оборудованием (атрибут title у el-option) [Claude Code]
    Chroma10bitHwNotSupport: '10-бит недоступен (не поддерживается оборудованием)',
    // RPSV3-136: двусторонняя подсказка взаимоисключения 4:2:2 и Forced 8-bit [Claude Code]
    Chroma422Requires10bit: '4:2:2 требует 10-бит',
    // Решение A: предупреждающий значок для недопустимой (выбранное значение попадает в запрещённое множество) комбинации [Claude Code]
    ChromaIllegalComboWarning: 'Текущая конфигурация не поддерживается этим оборудованием, переключитесь на допустимую комбинацию',
    EncodeWritePartialFail: 'Некоторые каналы кодирования не применили настройку. Повторите попытку.',
    RPSReadInfoFail: 'Не удалось прочитать состояние устройства. Повторите попытку.',
    // CC-2282: 补齐缺失 key（此前无 ru 翻译，走 en 兜底）；同一接收机的同一信号源（SDI/Pack）不能用于两路回传输出 [Claude Code]
    sameRTip: 'Один и тот же источник (SDI/Pack) на одном приёмнике нельзя использовать для двух выходов обратного видео.',
    // CC-2291: 补齐 ru 翻译（本文件走 en 兜底的残桩，用到的新 key 顺手补，成本为零）；改格式后已启用路需重启才能生效 [Claude Code]
    formatChangeInterruptTip: 'Смена видеоформата приведёт к кратковременному прерыванию обратного видео. Переключить сейчас?',
    // CC-2291 补：重启（stop/start）任一步失败时提示，避免 UI 与设备状态静默分叉 [Claude Code]
    formatChangeRestartFailed: 'Не удалось переключить видеоформат. Обратное видео может быть прервано. Проверьте состояние устройства.',
    // CC-2293：RPS81 写操作统一反馈出口新增 key，三语同步（本文件其余大量 key 走 en 兜底的
    // 残桩，但新增 key 按规约必须三语齐全，顺手补齐） [Claude Code]
    rpsOpSuccessTip: 'Операция выполнена успешно.',
    rpsOpTimeoutTip: 'Устройство не отвечает. Проверьте соединение и повторите попытку.',
    // W4（Step 5.5 真机坐实）：обрыв соединения — запрос не был доставлен устройству,
    // формулировка не должна упоминать "устройство" [Claude Code]
    rpsOpDisconnectedTip: 'Соединение потеряно. Проверьте сеть и повторите попытку.',
    rpsOpFailedTip: 'Операция не выполнена. Повторите попытку.',
    rpsOpPartialFailedTip: 'Некоторые операции не выполнены: {0}'
  }
}
